"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeOrderByForTable = exports.orderBy = void 0;
const zod_1 = require("zod");
exports.orderBy = zod_1.z
    .object({
    column: zod_1.z.string(),
    order: zod_1.z.enum(["ASC", "DESC"]),
})
    .nullable();
const ALL_TIME_COLUMN_ALIASES = ["timestamp", "startTime", "createdAt"];
const TIME_COLUMN_ALIASES = {
    timestamp: ALL_TIME_COLUMN_ALIASES,
    startTime: ALL_TIME_COLUMN_ALIASES,
    createdAt: ALL_TIME_COLUMN_ALIASES,
};
const normalizeOrderByForTable = ({ orderBy, expectedTimeColumn, }) => {
    if (!orderBy)
        return orderBy;
    if (!TIME_COLUMN_ALIASES[expectedTimeColumn].includes(orderBy.column)) {
        return orderBy;
    }
    return {
        ...orderBy,
        column: expectedTimeColumn,
    };
};
exports.normalizeOrderByForTable = normalizeOrderByForTable;
